export default __webpack_public_path__ + "static/media/algolab.9d04a2aa.webp";